import React from "react";
import { Link } from "react-router-dom";
// import Vacancy from "./Vacancy";

export function NavbarSet() {


    return (
   <>

<nav class="bg-white dark:bg-gray-800 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
  <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
  <a href={'/'} class="flex items-center space-x-3 rtl:space-x-reverse">
      <img src="https://cdni.iconscout.com/illustration/premium/thumb/job-vacancy-illustration-download-in-svg-png-gif-file-formats--hiring-applicants-opportunity-apply-for-employee-process-pack-business-illustrations-5712896.png?f=webp" class="h-8" alt="Prakerja Logo" />
      <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">FindJobs</span>
  </a>
  <div class="items-center justify-between w-full md:flex md:w-auto md:order-1" id="navbar-sticky"> 
    <ul class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-800 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-800 dark:border-gray-700">
      <li>
        <Link to='/' class="block py-2 pl-3 text-gray-700 md:bg-transparent md:text-blue-700 md:dark:text-blue-500" aria-current="page">Home </Link> 
        {/* <a href={'/'} class="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500" aria-current="page">Home</a> */}
      </li>
      <li>
        <Link to='/vacancy' class="block py-2 pl-3 text-gray">Vacancy</Link>
        {/* <a href={'vacancy'} class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Vacancy</a> */}
      </li>
      <li>
        <Link to='/contact' class="block py-2 pl-3 text-gray-700">Contact</Link>
        {/* <a href={'/contact'} class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700">Contact</a> */}
      </li>
    </ul>
  </div>
  </div>
</nav>
   </>

  );
}

export default NavbarSet